module.exports = __webpack_public_path__ + "static/media/20210109_230221_366_IMG_1862.7403884a.jpg";